import { render, staticRenderFns } from "./CustomTargetting.vue?vue&type=template&id=e7c61642&"
import script from "./CustomTargetting.vue?vue&type=script&lang=ts&"
export * from "./CustomTargetting.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTargetting.vue?vue&type=style&index=0&id=e7c61642&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports